
import { defineComponent } from 'vue'
import Heading from '@/components/Heading.vue'

export default defineComponent({
  components: {
    Heading
  },

  props: {
    tag: {
      default: 'h1',
      type: String
    }
  }
})
